var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoAltFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "geo-alt-fill",
    d: "M8,16s6-5.686,6-10A6,6,0,1,0,2,6C2,10.314,8,16,8,16ZM8,9a3,3,0,1,1,3-3A3,3,0,0,1,8,9Z",
    transform: "translate(-2)",
    fill: "#ed1c24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoAltFill);
export default __webpack_public_path__ + "static/media/geo-alt-fill.a11c7849b9d05582cdb9833f60c7767b.svg";
export { ForwardRef as ReactComponent };